import React from "react";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/index.route";
import { Provider } from "react-redux";
import { store } from "./store";
import { Toaster } from "react-hot-toast";
import { GlobalToast } from "./components/toast/toast-container";
import { ThemeProvider } from "./context/theme.context";
// Import services to register their endpoints
import "src/features/organizations/organization.service";

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider>
        <Toaster position='top-right' />
        <BrowserRouter>
          <AppRoutes />
          <GlobalToast />
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
